<template>
  <div class="rodo-container" v-show="dataReady">
    <Headline value="Twoje <b>dane</b>" number="1" />
    <div class="rodo-container__section rodo-userdata">
      <TextInput name="firstName" placeholder="Jakub"
        label="Imię*"
        :firstLetterUppercase="true"
        data-vv-validate-on="change"
        v-model="formFields[0].value"
        v-validate="{ required: true, regex: /^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]{2,}$/ }" />

      <TextInput name="lastName" placeholder="Nowak"
        label="Nazwisko*"
        :firstLetterUppercase="true"
        data-vv-validate-on="change"
        v-model="formFields[1].value"
        v-validate="{ required: true, regex: /^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]{2,}[\s\-]{0,1}[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]{0,}$/ }" />

      <TextInput name="email" placeholder="jnowak@test.pl"
        label="email*" 
        class="form-field--email"
        :readonly="true"
        v-model="formFields[2].value"
        v-validate="'required|email'" />

      <TextInput name="phone" placeholder="np. 555 555 555"
        label="Telefon" 
        data-vv-validate-on="change"
        v-model="formFields[3].value"
        v-validate="{ regex: /^[\+]{0,1}[0-9]{9,22}$/ }" />
    </div>
    
    <Headline value="<b>Potwierdź</b> oświadczenia" number="2" />
    <div class="rodo-container__section rodo-agreements">
      <CheckList ref="list" class="rodo-agreements--list" v-model="agreements" />
    </div>

    <RodoRegulations v-if="regulations" class="rodo-container__section" :preamble="regulationPreamble" :body="regulationBody" />

    <button @click="sendForm" class="rodo-container__button">
      Zgadzam się
      <Icon icon="v-right" />
    </button>

  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import CheckList from '@/components/CheckList.vue'
import DataReadyMixin from '@/components/DataReadyMixin'
import TextInput from '@/components/forms/fields/TextInput.vue'
import Headline from '@/components/forms/Headline.vue'
import { AgreementsLogic } from '@/components/forms/logic/RodoAgreements'
import { FormFieldsLogic } from '@/components/forms/logic/RodoFormFieldsData'
import RodoRegulations from '@/components/forms/RodoRegulations.vue'
import Icon from '@/components/Icon.vue'
import { getAgreementsRegulation } from '@/services/RodoRegulations'
import Observer from '@/utils/observer'
import QueryString from '@/utils/QueryString'

@Component({
  mixins: [
    DataReadyMixin,
    AgreementsLogic,
    FormFieldsLogic,
  ],
  components: {
    Headline,
    TextInput,
    CheckList,
    Icon,
    RodoRegulations,
  },
  props: {
    form: {
      type: HTMLFormElement,
      required: true,
    },
    regulations: {
      type: HTMLElement,
      required: false,
    },
  },
})
export default class Rodo extends Vue {
  validFields = false
  regulationPreamble = ''
  regulationBody = []

  get emailFromUrl () {
    return new QueryString().get('utm_email')
  }

  get emailField () {
    for (const item of this.formFields) {
      if (item.el.type === 'email') return item
    }

    return false
  }

  set emailField (value) {
    this.emailField.value = value
  }

  created () {
    if (this.regulations) this.getRegulations()
    this.emailField = this.emailFromUrl
    this.markDataAsReady()
  }

  getRegulations () {
    getAgreementsRegulation()
      .then(data => {
        this.regulationPreamble = data.preamble
        this.regulationBody = data.body
      })
  }
  
  saveValuesToForm () {
    this.dx.agreements.data = this.agreements
    this.dx.formFields.data = this.formFields
  }

  redirectPageAfterFormSend () {
    const target = this.form
    const config = { childList: true }
    const type = 'childList'

    return new Observer(target, config, type).observe(() => {
      const url = `${window.location.origin}/zgody-potwierdzenie`
      window.location.replace(url)
    })
  }
  
  updateAvailableValues () {
    this.saveValuesToForm()
    this.redirectPageAfterFormSend()
    this.form.submitWFFM()
  }

  sendForm () {
    this.$validator.validateAll().then(result => {
      if (result) this.updateAvailableValues()
    })
  }
}
</script>

<style lang="scss">
.rodo-container {
  width: 100%;
  max-width: 845px;
  margin: 0 auto 30px;
  font-family: 'Gotham Book';
  padding: 0 10px;

  &__section {
    margin-bottom: 30px;
    padding: 25px 20px;
    background-color: #fff;
    color: #0057A8;

    &.rodo-regulation {
      color: #535353;
    }
  }

  &__button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    background-color: #009FEA;
    color: #fff;
    text-transform: uppercase;
    font-size: 12px;
    font-family: 'Gotham';
    font-weight: bold;
    border: 0;
    border-radius: 0;
    width: 156px;
    height: 36px;
    padding-left: 20px;

    .figure {
      font-size: 18px;
      padding-top: 10px;
      margin-left: 13px;
    }
  }

  .rodo-userdata {
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 1fr 20px 1fr;
    -ms-grid-rows: 47px 20px 47px;
    grid-template-columns: 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 20px;

    @media screen and (min-width: 768px) {
      grid-template-columns: 1fr 1fr;
    }

    .form-field:nth-child(1) {
      -ms-grid-row: 1;
      -ms-grid-column: 1;
    }
    .form-field:nth-child(2) {
      -ms-grid-row: 1;
      -ms-grid-column: 3;
    }
    .form-field:nth-child(3) {
      -ms-grid-row: 3;
      -ms-grid-column: 1;
    }
    .form-field:nth-child(4) {
      -ms-grid-row: 3;
      -ms-grid-column: 3;
    }
    .form-field--email input {
      cursor: default;
      pointer-events: none;
    }

    .text-input::before {
      top: 23px;
    }
  }

  .rodo-agreements {
    margin-bottom: 30px;

    p {
      color: #535353;
      line-height: 18px;
      font-size: 10px;
      font-weight: normal;
      margin: 0;
    }
  }

  .checklist-item {
    align-items: start;

    &__label {
      color: #535353;
      line-height: 18px;
      font-family: 'Gotham Book';
      font-size: 10px;
      font-weight: normal;

      // because component is reused, we need to override this hover to fit with layout
      &:hover {
        color: #535353 !important;
      }
    }

    &__checkbox {
      margin-top: 5px !important;
      flex: 0 0 auto;
    }

    a {
      text-transform: uppercase;
      text-decoration: underline;
      color: #005CA9;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
  .checkbox {
    background-color: transparent !important;
    border: 2px solid #005CA9;

    &::before {
      color: transparent;
    }

    &--checked::before {
      top: -6px !important;
      left: 1px !important;
      color: #005CA9;
      font-weight: bold;
    }
  }
}
</style>

<style>
.rodo-form {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Rodo.vue